import { render, staticRenderFns } from "./Preview3D.vue?vue&type=template&id=035d71b6&scoped=true"
import script from "./Preview3D.vue?vue&type=script&lang=js"
export * from "./Preview3D.vue?vue&type=script&lang=js"
import style0 from "./Preview3D.vue?vue&type=style&index=0&id=035d71b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d71b6",
  null
  
)

export default component.exports